import React from 'react'

const CourseDetail = () => {
  return (
    <div className='coursedetail-container'>
        <ul>
            <li>Front end skills – Get a deeper look at the front end development.</li>
            <li>Learn HTML, CSS  and JavaScript</li>
            <li>Learn and strength your ReactJS Skills</li>
            <li>Understand Redux for state management and Redux Thunk</li>
            <li>Learn about Axios for sending HTTP request to the backend</li>
            <li>Backend Skills – Learn and explore with us Nodejs, Expressjs.</li>
            <li>App development using Nodejs</li>
            <li>Learn about CRUD operation using MongooseJS</li>
            <li>Understand Json web tokens for authentication.</li>
            <li>Database – Getting better clarity about cloud platforms for database deployment.</li>
            <li>Develop skills – Build full stack GitHub portfolio</li>
            <li>Learn about git operations</li>
            <li>Learn Netify for deploying the front-end</li>
            <li>Learn  Heroku for deploying the backend.</li>
        </ul>
    </div>
  )
}

export default CourseDetail